import { render, staticRenderFns } from "./Leader.vue?vue&type=template&id=c4e41dac&scoped=true"
import script from "./Leader.vue?vue&type=script&lang=js"
export * from "./Leader.vue?vue&type=script&lang=js"
import style0 from "./Leader.vue?vue&type=style&index=0&id=c4e41dac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e41dac",
  null
  
)

export default component.exports